import axios, { AxiosResponse } from 'axios';

import config from '../../config_crypto-sign'
import { SignInfoResponse, SignInfoRequest } from '@/data/crypto-sign-info-types/types'
import { signInfoMockData } from '@/data/crypto-sign-info-types/mocks'

const instance = axios.create({
    baseURL: config.tenderMVCSiteUrl,
    timeout: 100000,
    withCredentials: true,
    headers: {Pragma: 'no-cache'}
});

const request = process.env.VUE_APP_IS_LOCAL === 'true' ? 
  new Promise<AxiosResponse<SignInfoResponse>>((resolve) => resolve(signInfoMockData)) : 
  instance.post<SignInfoResponse>('/Cryptosign/GetCryptoSignInfo');

export class TenderWebApi {
  // public static getCryptoSignInfo = (data: SignInfoRequest): Promise<AxiosResponse<SignInfoResponse>> => request;
  public static getCryptoSignInfo = (data: SignInfoRequest): Promise<AxiosResponse<SignInfoResponse>> => instance.post<SignInfoResponse>('/Cryptosign/GetCryptoSignInfo', data);

}
